export default () => ({
    atletas: [],
    atletaSeleccionado: {},
    codigos: '',
    codigo: '',
})